"use strict";
'use client';
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDisablePullToRefresh = void 0;
var react_1 = require("react");
var useDisablePullToRefresh = function () {
    (0, react_1.useEffect)(function () {
        if (typeof window !== 'undefined') {
            var html = document.documentElement;
            document.body.style.overscrollBehaviorY = 'contain';
            document.body.style.overscrollBehavior = 'none';
            document.body.style.touchAction = 'none';
            html.style.overscrollBehaviorY = 'contain';
            html.style.overscrollBehavior = 'none';
            html.style.touchAction = 'none';
        }
        return function () {
            if (typeof window !== 'undefined') {
                var html = document.documentElement;
                document.body.style.overscrollBehaviorY = '';
                document.body.style.overscrollBehavior = '';
                document.body.style.touchAction = '';
                html.style.overscrollBehaviorY = '';
                html.style.overscrollBehavior = '';
                html.style.touchAction = '';
            }
        };
    }, []);
};
exports.useDisablePullToRefresh = useDisablePullToRefresh;
